import { render, staticRenderFns } from "./DialogThankYou.vue?vue&type=template&id=b303fa78&scoped=true"
import script from "./DialogThankYou.vue?vue&type=script&lang=js"
export * from "./DialogThankYou.vue?vue&type=script&lang=js"
import style0 from "./DialogThankYou.vue?vue&type=style&index=0&id=b303fa78&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b303fa78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b303fa78')) {
      api.createRecord('b303fa78', component.options)
    } else {
      api.reload('b303fa78', component.options)
    }
    module.hot.accept("./DialogThankYou.vue?vue&type=template&id=b303fa78&scoped=true", function () {
      api.rerender('b303fa78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/Dialogs/DialogThankYou.vue"
export default component.exports